<template>
  <b-modal centered v-model="showModal" :hide-footer="true">
    <div slot="modal-title">
      รายละเอียดบริการ
    </div>
    <div>
      <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/firework/attachments/350242956-769701527957934-1953166898944016967-n-png_1685178670982.png" alt="" class="img-fluid">
    </div>
  </b-modal>
</template>

<script>
  export default {
    data () {
      return {
        showModal: false
      }
    },
    methods: {
      showPopupModal (status) {
        this.showModal = status
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/PopupModal.vue